module.exports = __webpack_public_path__ + "static/media/bunawi.d53d84e2.png";